import { defineMessages } from 'react-intl'

export default defineMessages({
  security: {
    id: 'containers.UserSettingsPage.components.Security.security',
    defaultMessage: 'Security',
  },
  beCareful: {
    id: 'containers.UserSettingsPage.components.Security.beCareful',
    defaultMessage: 'This area of the settings can lock you out. Act carefully.',
  },
  password: {
    id: 'containers.UserSettingsPage.components.Security.password',
    defaultMessage: 'Password',
  },
  reset: {
    id: 'containers.UserSettingsPage.components.Security.reset',
    defaultMessage: 'Reset',
  },
})
